module.exports = __webpack_public_path__ + "img/quanta-play.fb9a04e5.gif";